// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import { UWD_CHAMBER, UWD_CHAMBER_EXPERT, UWD_CHAMBER_PROJECT } from "./formFields";

type UwdInfoProps = {
  initialValues: {
    [typeof UWD_CHAMBER]: ?string,
    [typeof UWD_CHAMBER_EXPERT]: ?string,
    [typeof UWD_CHAMBER_PROJECT]: ?string
  }
};

const UwdInfo = ({ initialValues }: UwdInfoProps) => {
  if (!Object.values(initialValues).some(Boolean)) {
    return null;
  }

  return (
    <Section title="Unternehmenswerkstatt" reducedMargin numbered>
      <EditableForm initialValues={initialValues} isLocked>
        <FormRow>
          <EditableField
            fieldControlProps={{
              name: UWD_CHAMBER,
              caption: () => "Kammer"
            }}
          />
          <EditableField
            fieldControlProps={{
              name: UWD_CHAMBER_EXPERT,
              caption: () => "Kammerexperte"
            }}
          />
          <EditableField
            fieldControlProps={{
              name: UWD_CHAMBER_PROJECT,
              caption: () => "Kammerprojekt"
            }}
          />
        </FormRow>
      </EditableForm>
    </Section>
  );
};

export default UwdInfo;
